import * as angular from 'angular';
import {TopToolChange} from "../../models/activity/gobActivity";
import ToolActivity from "../../models/activity/toolActivity";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import ToolChangeServiceName, {ToolChangeService} from "../../services/toolChange/toolChange.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import template from './viewToolChange.tpl.html';

let requires = [LoaderServiceName, NotifyServiceName, ToolChangeServiceName];

export interface ViewToolChangeParams {
  timeZoneId: string;
  toolChanges: TopToolChange;
  readOnly: boolean;
  canComment: boolean;
  canEdit: boolean;
}

export interface ViewToolChangeResponse {
  action: string;
}

export function openViewToolChange(data: ViewToolChangeParams,
                                   $modal: mm.foundation.modal): angular.IPromise<ViewToolChangeResponse> {
  return $modal.open({
    template: template,
    controller: 'ViewToolChangeCtrl as vm',
    resolve: {
      data: function() {
        return data;
      }
    }
  }).result;
}

export interface ViewToolChangeController {
  tools: ToolActivity[];
  duration: number;
  timeChangedString: string;
  createdBy: string;
  timeZoneId: string;
  toolChangeId: string;
  comments: apsViewModels.ToolChangeDetailsComment[];
  comment: string;
  commentForm: any;
  readOnly: boolean;
  canComment: boolean;
  canEdit: boolean;

  close(): void;
  deleteChange(): void;
  edit(): void;
  addComment(): void;
}

export class ViewToolChangeCtrl implements ViewToolChangeController {
  loaderService: LoaderService;
  notifyService: NotifyService;
  toolChangeService: ToolChangeService;
  data: ViewToolChangeParams;
  tools: ToolActivity[];
  duration: number;
  timeChangedString: string;
  createdBy: string;
  timeZoneId: string;
  toolChangeId: string;
  readOnly: boolean;
  comments: apsViewModels.ToolChangeDetailsComment[];
  comment: string;
  commentForm: any;
  canComment: boolean;
  canEdit: boolean;

  close() {
    this.$modalInstance.close();
  }

  deleteChange() {
    let promise = this.toolChangeService
      .deleteToolChange ({ id: this.data.toolChanges.id })
      .then(() => {
        this.$modalInstance.close({action: 'delete'});
      }, this.notifyService.handleApiErrors);
    this.loaderService.loadingPromise(promise);
  }

  edit() {
    this.$modalInstance.close({action: 'edit'});
  }

  addComment() {
    if (this.commentForm.$invalid) {
      return;
    }

    let command = {
      toolChangeId: this.toolChangeId,
      comment: this.comment
    };

    let promise = this.toolChangeService.addComment(command)
      .then(() => {
        this.$modalInstance.close({action: 'addComment', detail: command});
      }, this.notifyService.handleApiErrors);

    this.loaderService.loadingPromise(promise);
  }

  formatTime (time) {
    return DateUtilityService.formatTime(time, this.timeZoneId);
  }

  private $modalInstance: mm.foundation.modalInstance;

  constructor(
    $modalInstance: mm.foundation.modalInstance,
    loaderService: LoaderService,
    notifyService: NotifyService,
    toolChangeService: ToolChangeService,
    data: ViewToolChangeParams) {
    this.$modalInstance = $modalInstance;
    this.loaderService = loaderService;
    this.notifyService = notifyService;
    this.toolChangeService = toolChangeService;
    this.data = data;
    this.timeZoneId = data.timeZoneId;
    let tool = data.toolChanges.tools[0];
    this.timeChangedString = tool.getTimeChanged();
    this.tools = data.toolChanges.tools;
    this.duration = tool.duration;
    this.createdBy = tool.createdByFullName;
    this.comments = data.toolChanges.comments;
    this.toolChangeId = tool.toolChangeId;
    this.readOnly = data.readOnly;
    this.canComment = data.canComment;
    this.canEdit = !data.readOnly && data.canEdit;
  }
}

export default angular
  .module('aps.controller.viewToolChange', requires)
  .controller('ViewToolChangeCtrl', ViewToolChangeCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/toolChange/viewToolChange.controller.ts